import { render, staticRenderFns } from "./DialogAddLecture.vue?vue&type=template&id=abff7a96"
import script from "./DialogAddLecture.vue?vue&type=script&lang=js"
export * from "./DialogAddLecture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abff7a96')) {
      api.createRecord('abff7a96', component.options)
    } else {
      api.reload('abff7a96', component.options)
    }
    module.hot.accept("./DialogAddLecture.vue?vue&type=template&id=abff7a96", function () {
      api.rerender('abff7a96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddLecture.vue"
export default component.exports